module.exports = __webpack_public_path__ + "img/photo02.4b246a33.jpg";